<mat-card>
  <app-card-header
    icono="router"
    [title]="title"
    [subtitle]="subtitle"
    [draggable]="!!dialogRef"
  ></app-card-header>

  <mat-divider></mat-divider>

  @if (!loading) {
    @if (form || formMasivo) {
      <mat-card-content
        [class.cardContentDialog]="dialogRef"
        [class.cardContentFullscreen]="!dialogRef && !subtitle"
        [class.cardContentFullscreenSubtitle]="!dialogRef && subtitle"
        class="card-content-crear"
      >
        <!-- Toggle para modo masivo (solo en creación) -->
        @if (!isEditing) {
          <div style="padding: 16px 0 8px 0">
            <mat-slide-toggle
              [checked]="modoMasivo"
              (change)="toggleModoMasivo()"
              color="primary"
            >
              <strong>Carga Masiva</strong>
            </mat-slide-toggle>
            <p
              style="
                margin: 0.5em 0 0 0;
                font-size: 0.9em;
                color: var(--color-text-secondary);
              "
            >
              @if (modoMasivo) {
                Cargá múltiples dispositivos desde CSV
              } @else {
                Crear un dispositivo individual
              }
            </p>
          </div>
        }

        <!-- ═══════════════════════════════════════ -->
        <!-- MODO INDIVIDUAL                         -->
        <!-- ═══════════════════════════════════════ -->
        @if (!modoMasivo && form) {
          <form [formGroup]="form" autocomplete="off">
            <!-- Datos Generales -->
            <app-content-card
              title="Datos Generales"
              icon="router"
              color="blue"
            >
              <section class="inputs-group" style="flex-direction: column">
                <div style="display: flex; gap: 1em; width: 100%">
                  <mat-form-field style="flex: 1">
                    <mat-label>Nombre</mat-label>
                    <input matInput formControlName="name" />
                    <mat-icon matPrefix>label</mat-icon>
                  </mat-form-field>

                  @if (mostrarCamposCliente) {
                    <app-cliente-selector
                      formControlName="idCliente"
                      style="flex: 1"
                      [showCrearBtn]="
                        helper.tienePermiso('Administración - Crear clientes')
                      "
                    ></app-cliente-selector>
                  }
                </div>

                <mat-form-field style="width: 100%">
                  <mat-label>Descripción</mat-label>
                  <textarea
                    matInput
                    formControlName="description"
                    style="min-height: 80px"
                  ></textarea>
                  <mat-icon matPrefix>notes</mat-icon>
                </mat-form-field>
              </section>
            </app-content-card>

            <!-- Identificación LoRaWAN -->
            <app-content-card
              title="Identificación LoRaWAN"
              icon="fingerprint"
              color="green"
            >
              <section class="inputs-group">
                <div
                  style="
                    width: 100%;
                    display: flex;
                    gap: 8px;
                    align-items: flex-start;
                  "
                >
                  <mat-form-field style="flex: 1">
                    <mat-label>DevEUI</mat-label>
                    <input
                      matInput
                      formControlName="deveui"
                      [readonly]="isEditing"
                    />
                    <mat-icon matPrefix>fingerprint</mat-icon>
                    @if (form.controls['deveui'].hasError('hexInvalid')) {
                      <mat-error>
                        16 caracteres en formato hexadecimal.
                      </mat-error>
                    }
                  </mat-form-field>
                  <app-button
                    matType="mat-fab"
                    color="primary"
                    icon="shuffle"
                    tooltip="Valor aleatorio"
                    (click)="crearRandomDeveui()"
                    [disabled]="isEditing"
                  ></app-button>
                </div>

                <div
                  style="
                    width: 100%;
                    display: flex;
                    gap: 8px;
                    align-items: flex-start;
                  "
                >
                  <mat-form-field style="flex: 1">
                    <mat-label>JoinEUI</mat-label>
                    <input matInput formControlName="joineui" />
                    <mat-icon matPrefix>fingerprint</mat-icon>
                    @if (form.controls['joineui'].hasError('hexInvalid')) {
                      <mat-error>
                        16 caracteres en formato hexadecimal.
                      </mat-error>
                    }
                  </mat-form-field>
                  <app-button
                    matType="mat-fab"
                    color="primary"
                    icon="shuffle"
                    tooltip="Valor aleatorio"
                    (click)="crearRandomJoineui()"
                  ></app-button>
                </div>
              </section>
            </app-content-card>

            <!-- Tipo y Perfil -->
            <app-content-card
              title="Tipo y Perfil"
              icon="devices"
              color="purple"
            >
              <section class="inputs-group">
                <div style="width: 100%">
                  <ng-select
                    [fixedPlaceholder]="true"
                    style="width: 100%"
                    [items]="tipos"
                    formControlName="tipo"
                    placeholder="Tipo de dispositivo *"
                    multiple="false"
                    searchable="false"
                    appendTo="body"
                    [readonly]="isEditing"
                  ></ng-select>
                </div>

                <div style="width: 100%">
                  <ng-select
                    [fixedPlaceholder]="true"
                    style="width: 100%"
                    [items]="deviceProfiles"
                    bindLabel="name"
                    bindValue="id"
                    formControlName="deviceProfileId"
                    placeholder="Perfil del dispositivo *"
                    [notFoundText]="'No hay perfiles que coincidan'"
                    multiple="false"
                    searchable="true"
                    appendTo="body"
                    [readonly]="isEditing"
                    [hideSelected]="true"
                  ></ng-select>
                </div>

                <app-modelo-dispositivo-selector
                  style="width: 100%"
                  tipo="DispositivoLorawan"
                  formControlName="idModeloDispositivo"
                  [showCrearBtn]="
                    helper.tienePermiso(
                      'Configuraciones - Crear modelos dispositivos lorawan'
                    )
                  "
                ></app-modelo-dispositivo-selector>
              </section>
            </app-content-card>

            <!-- Seguridad (OTAA / ABP) -->
            @if (supportsOTAA !== null && supportsOTAA !== undefined) {
              <app-content-card title="Seguridad" icon="lock" color="orange">
                @if (supportsOTAA) {
                  <form [formGroup]="formOTAA" autocomplete="off">
                    <section class="inputs-group">
                      <div
                        style="
                          width: 100%;
                          display: flex;
                          gap: 8px;
                          align-items: flex-start;
                        "
                      >
                        <mat-form-field style="flex: 1">
                          <mat-label>Application Key</mat-label>
                          <input matInput formControlName="appkey" />
                          <mat-icon matPrefix>key</mat-icon>
                          @if (
                            formOTAA.controls['appkey'].hasError('hexInvalid')
                          ) {
                            <mat-error>
                              32 caracteres en formato hexadecimal.
                            </mat-error>
                          }
                        </mat-form-field>
                        <app-button
                          matType="mat-fab"
                          color="primary"
                          icon="shuffle"
                          tooltip="Valor aleatorio"
                          (click)="crearRandomAppkey()"
                        ></app-button>
                      </div>
                    </section>
                  </form>
                } @else {
                  <form [formGroup]="formABP" autocomplete="off">
                    <section class="inputs-group">
                      <div
                        style="
                          width: 100%;
                          display: flex;
                          gap: 8px;
                          align-items: flex-start;
                        "
                      >
                        <mat-form-field style="flex: 1">
                          <mat-label>DevAddr</mat-label>
                          <input matInput formControlName="devAddr" />
                          <mat-icon matPrefix>tag</mat-icon>
                          @if (
                            formABP.controls['devAddr'].hasError('hexInvalid')
                          ) {
                            <mat-error>
                              8 caracteres en formato hexadecimal.
                            </mat-error>
                          }
                        </mat-form-field>
                        <app-button
                          matType="mat-fab"
                          color="primary"
                          icon="shuffle"
                          tooltip="Valor aleatorio"
                          (click)="crearRandomDevAddr()"
                        ></app-button>
                      </div>

                      <div
                        style="
                          width: 100%;
                          display: flex;
                          gap: 8px;
                          align-items: flex-start;
                        "
                      >
                        <mat-form-field style="flex: 1">
                          <mat-label>AppSKey</mat-label>
                          <input matInput formControlName="appSKey" />
                          <mat-icon matPrefix>key</mat-icon>
                          @if (
                            formABP.controls['appSKey'].hasError('hexInvalid')
                          ) {
                            <mat-error>
                              32 caracteres en formato hexadecimal.
                            </mat-error>
                          }
                        </mat-form-field>
                        <app-button
                          matType="mat-fab"
                          color="primary"
                          icon="shuffle"
                          tooltip="Valor aleatorio"
                          (click)="crearRandomAppSKey()"
                        ></app-button>
                      </div>

                      <div
                        style="
                          width: 100%;
                          display: flex;
                          gap: 8px;
                          align-items: flex-start;
                        "
                      >
                        <mat-form-field style="flex: 1">
                          <mat-label>NwkSKey</mat-label>
                          <input matInput formControlName="nwkskey" />
                          <mat-icon matPrefix>key</mat-icon>
                          @if (
                            formABP.controls['nwkskey'].hasError('hexInvalid')
                          ) {
                            <mat-error>
                              32 caracteres en formato hexadecimal.
                            </mat-error>
                          }
                        </mat-form-field>
                        <app-button
                          matType="mat-fab"
                          color="primary"
                          icon="shuffle"
                          tooltip="Valor aleatorio"
                          (click)="crearRandomNwkSKey()"
                        ></app-button>
                      </div>

                      <div style="width: 100%; display: flex; gap: 16px">
                        <mat-form-field style="flex: 1">
                          <mat-label>Uplink frame-counter</mat-label>
                          <input matInput formControlName="fCntUp" />
                        </mat-form-field>
                        <mat-form-field style="flex: 1">
                          <mat-label>Downlink frame-counter</mat-label>
                          <input matInput formControlName="nFCntDown" />
                        </mat-form-field>
                      </div>
                    </section>
                  </form>
                }
              </app-content-card>
            }

            <!-- Monitoreo -->
            <app-content-card
              title="Monitoreo"
              icon="monitor_heart"
              color="teal"
            >
              <section class="inputs-group">
                <mat-form-field style="max-width: 320px">
                  <mat-label>Tiempo límite de comunicación (hs)</mat-label>
                  <input
                    matInput
                    type="number"
                    formControlName="tiempoLimiteComunicacion"
                    min="1"
                  />
                  <mat-icon matPrefix>timer</mat-icon>
                  <mat-icon
                    matSuffix
                    matTooltip="Máximo sin reportar antes de generar alerta. Por defecto: 24 hs"
                    style="
                      cursor: help;
                      font-size: 18px;
                      color: var(--color-text-secondary);
                    "
                  >
                    info
                  </mat-icon>
                  @if (
                    form.controls['tiempoLimiteComunicacion'].hasError('min')
                  ) {
                    <mat-error>Debe ser mayor a 0</mat-error>
                  }
                </mat-form-field>
              </section>
            </app-content-card>

            <!-- Opciones -->
            <app-content-card title="Opciones" icon="tune" color="gray">
              <section class="inputs-group">
                <app-checkbox
                  title="¿Dispositivo deshabilitado?"
                  formControlName="isDisabled"
                ></app-checkbox>
                <app-checkbox
                  title="¿Frame-counter validation deshabilitado?"
                  formControlName="skipFcntCheck"
                  [disabled]="ReadOnlyWellness()"
                ></app-checkbox>
              </section>
            </app-content-card>
          </form>
        }

        <!-- ═══════════════════════════════════════ -->
        <!-- MODO MASIVO                             -->
        <!-- ═══════════════════════════════════════ -->
        @if (modoMasivo && formMasivo) {
          <form [formGroup]="formMasivo" autocomplete="off">
            <!-- Configuración común -->
            <app-content-card
              title="Configuración Común"
              icon="settings"
              color="blue"
            >
              <section class="inputs-group">
                @if (mostrarCamposCliente) {
                  <app-cliente-selector
                    formControlName="idCliente"
                    style="width: 100%"
                    [showCrearBtn]="
                      helper.tienePermiso('Administración - Crear clientes')
                    "
                  ></app-cliente-selector>
                }

                <div style="width: 100%">
                  <ng-select
                    [fixedPlaceholder]="true"
                    style="width: 100%"
                    [items]="tipos"
                    formControlName="tipo"
                    placeholder="Tipo de dispositivo *"
                    multiple="false"
                    searchable="false"
                    appendTo="body"
                  ></ng-select>
                </div>

                <div style="width: 100%">
                  <ng-select
                    [fixedPlaceholder]="true"
                    style="width: 100%"
                    [items]="deviceProfiles"
                    bindLabel="name"
                    bindValue="id"
                    formControlName="deviceProfileId"
                    placeholder="Perfil del dispositivo *"
                    [notFoundText]="'No hay perfiles que coincidan'"
                    multiple="false"
                    searchable="true"
                    appendTo="body"
                    [hideSelected]="true"
                  ></ng-select>
                </div>

                <app-modelo-dispositivo-selector
                  style="width: 100%"
                  tipo="DispositivoLorawan"
                  formControlName="idModeloDispositivo"
                  [showCrearBtn]="
                    helper.tienePermiso(
                      'Configuraciones - Crear modelos dispositivos lorawan'
                    )
                  "
                ></app-modelo-dispositivo-selector>
              </section>
            </app-content-card>

            <!-- Monitoreo (default para todos) -->
            <app-content-card
              title="Monitoreo"
              icon="monitor_heart"
              color="teal"
            >
              <section class="inputs-group">
                <mat-form-field style="max-width: 320px">
                  <mat-label>Tiempo límite de comunicación (hs)</mat-label>
                  <input
                    matInput
                    type="number"
                    formControlName="tiempoLimiteComunicacion"
                    min="1"
                  />
                  <mat-icon matPrefix>timer</mat-icon>
                  <mat-icon
                    matSuffix
                    matTooltip="Default para todos. Se puede sobreescribir por fila en CSV (columna 5)"
                    style="
                      cursor: help;
                      font-size: 18px;
                      color: var(--color-text-secondary);
                    "
                  >
                    info
                  </mat-icon>
                  @if (
                    formMasivo.controls['tiempoLimiteComunicacion'].hasError(
                      'min'
                    )
                  ) {
                    <mat-error>Debe ser mayor a 0</mat-error>
                  }
                </mat-form-field>
              </section>
            </app-content-card>

            <!-- Datos CSV -->
            <app-content-card
              title="Datos CSV"
              icon="upload_file"
              color="green"
            >
              <section class="inputs-group">
                <app-info-banner
                  icon="info"
                  title="Formato de Carga CSV"
                  message="Formato: <code style='padding: 2px 6px; border-radius: 3px'>Deveui, DeviceName, JoinEUI, AppKey, TiempoLimite</code><br/><strong>Requisitos:</strong><br/>• Un dispositivo por línea<br/>• DevEUI: 16 caracteres hexadecimales (obligatorio)<br/>• DeviceName: nombre del dispositivo (obligatorio)<br/>• JoinEUI: 16 caracteres hexadecimales (opcional, si no se proporciona se usa DevEUI)<br/>• AppKey: 32 caracteres hexadecimales (opcional)<br/>• TiempoLimite: horas sin reportar antes de generar alerta (opcional, si no se especifica usa el valor del formulario)"
                  margin="0 0 8px 0"
                ></app-info-banner>

                <mat-form-field style="width: 100%">
                  <textarea
                    matInput
                    [(ngModel)]="csvData"
                    [ngModelOptions]="{ standalone: true }"
                    placeholder="A1B2C3D4E5F60718, Dispositivo 1, A1B2C3D4E5F60718, 1A2B3C4D5E6F708192A3B4C5D6E7F809&#10;19283746AB56CDEF, Dispositivo 2"
                    style="
                      min-height: 200px;
                      font-family: var(--font-family-monospace);
                      font-size: 0.9em;
                      resize: vertical;
                    "
                  ></textarea>
                </mat-form-field>

                @if (validationErrors.length > 0) {
                  <div
                    style="
                      border-left: 4px solid #f44336;
                      padding: 1em;
                      border-radius: 4px;
                    "
                  >
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        gap: 0.5em;
                        margin-bottom: 0.5em;
                      "
                    >
                      <mat-icon color="warn">error_outline</mat-icon>
                      <strong style="color: #c62828">
                        Errores de validación:
                      </strong>
                    </div>
                    @for (error of validationErrors; track error.line) {
                      <p
                        style="
                          margin: 0.3em 0;
                          font-size: 0.9em;
                          color: #c62828;
                        "
                      >
                        <strong>Línea {{ error.line }}:</strong>
                        {{ error.error }}
                      </p>
                    }
                  </div>
                }
              </section>
            </app-content-card>

            <!-- Opciones -->
            <app-content-card title="Opciones" icon="tune" color="gray">
              <section class="inputs-group">
                <app-checkbox
                  title="¿Dispositivos deshabilitados?"
                  formControlName="isDisabled"
                ></app-checkbox>
                <app-checkbox
                  title="¿Frame-counter validation deshabilitado?"
                  formControlName="skipFcntCheck"
                  [disabled]="isSkipFcntCheckReadOnly"
                ></app-checkbox>
              </section>
            </app-content-card>
          </form>
        }
      </mat-card-content>

      <mat-divider></mat-divider>
      <mat-card-actions class="actions-create">
        <app-button
          matType="mat-fab extended"
          color="neutral"
          (click)="this.helper.volver()"
          text="Cancelar"
          icon="close"
        ></app-button>
        <app-button
          matType="mat-fab extended"
          [disabled]="
            modoMasivo
              ? !formMasivo?.valid || !csvData.trim() || processingMasivo
              : !(form?.valid && (formABP?.valid || formOTAA?.valid))
          "
          color="primary"
          [text]="processingMasivo ? 'Procesando...' : 'Guardar'"
          icon="save"
          (click)="onSubmit()"
        ></app-button>
      </mat-card-actions>
    }
  } @else {
    <section class="inputs-group">
      <app-loading text="Cargando formulario..." [diameter]="60"></app-loading>
    </section>
  }
</mat-card>
